export enum TradeInProvider {
  //TODO: Update value to Assurant once back end is caught up
  Assurant = 'HYLA',
}
